export class CustomerError extends Error {
    type: CustomerErrorType;

    constructor(type: CustomerErrorType, message?: string) {
        super(message ?? CustomerErrorMessages[type]);

        this.type = type;
    }
}

export enum CustomerErrorType {
    PhoneAlreadyTaken = 'PhoneAlreadyTaken',
    Unknown = 'Unknown'
}

export const CustomerErrorMessages: Record<CustomerErrorType, string> = {
    [CustomerErrorType.PhoneAlreadyTaken]: 'This phone number is already taken.',
    [CustomerErrorType.Unknown]: 'Oops, something went wrong.'
};
